import {
  Button,
  Center,
  Text,
  VStack,
  HStack,
  Box,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
  Flex,
  useDisclosure,
  Alert,
  AlertIcon,
  Select,
} from '@chakra-ui/react';
import axios from 'axios';
import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  updateWarrantyOption,
  updateFinanceOption,
} from '../features/calculator/calculatorSlice';

import useUser from '../hooks/useUser';

const Options = ({ setCalculateButtonClicked, isMobileDevice }) => {
  const { user } = useUser();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const warrantyOption = useSelector(state => state.calculator.warrantyOption);
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [tempWarrantyOption, setTempWarrantyOption] = useState(warrantyOption);

  const warrantyOptionOne = useSelector(
    state => state.calculator.warrantyOptionOne
  );
  const warrantyOptionTwo = useSelector(
    state => state.calculator.warrantyOptionTwo
  );

  const dispatch = useDispatch();

  const handleOpen = () => {
    onOpen();
  };

  const handleSave = async () => {
    try {
      const token = await user.getIdToken();
      await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/roofs/options`,
        {
          username: user.email,
          warrantyOption: tempWarrantyOption,
        },
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );
      dispatch(updateWarrantyOption(tempWarrantyOption));
      dispatch(updateFinanceOption('cash'));
      setUnsavedChanges(false);
      setCalculateButtonClicked(true);
      onClose();
    } catch (error) {
      console.log('error: ' + error);
    }
  };

  return (
    <Box
      minW={isMobileDevice ? '90vw' : ''}
      maxW={isMobileDevice ? '' : 'sm'}
      maxH="70px"
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      p={isMobileDevice ? '3' : '6'}
      boxShadow="base"
      borderColor="gray.400"
      bg={'gray.200'}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      cursor={isMobileDevice ? 'pointer' : 'default'}
      onClick={isMobileDevice ? handleOpen : null}
    >
      <Flex alignItems="center">
        <Text
          fontWeight="bold"
          fontSize="l"
          mr={isMobileDevice ? '0' : '4'}
          pl="10px"
        >
          Options
        </Text>
        {!isMobileDevice && (
          <Button
            size="sm"
            border="1px"
            borderColor="gray.600"
            ml="15px"
            onClick={handleOpen}
          >
            Edit
          </Button>
        )}
        <Modal
          isOpen={isOpen}
          size={{ base: 'full', md: 'lg' }}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalCloseButton />
            <ModalHeader>
              <HStack justify="space-between">
                <Text>Options</Text>
              </HStack>
            </ModalHeader>
            <ModalBody>
              <VStack align="flex-start">
                <Text fontSize={'sm'}>Warranty</Text>
                <Select
                  width="50%"
                  size={'sm'}
                  value={tempWarrantyOption}
                  onChange={event => {
                    setUnsavedChanges(true);
                    setTempWarrantyOption(event.target.value);
                  }}
                >
                  {warrantyOptionOne && (
                    <option value="standard">
                      {warrantyOptionOne} (Option 1)
                    </option>
                  )}
                  {warrantyOptionTwo && (
                    <option value="two">{warrantyOptionTwo} (Option 2)</option>
                  )}
                </Select>
                {unsavedChanges && (
                  <Alert status="warning">
                    <AlertIcon />
                    <VStack align="flex-start">
                      <Text fontSize="sm">You have unsaved changes!</Text>
                    </VStack>
                  </Alert>
                )}
                <Center></Center>
              </VStack>
            </ModalBody>
            <ModalFooter padding="10px">
              <Button
                onClick={handleSave}
                colorScheme="blue"
                ml={{ base: '0', md: '60px' }}
                w={{ base: '100%', md: 'auto' }}
              >
                Save
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </Flex>
    </Box>
  );
};

export default Options;
